import { render, staticRenderFns } from "./left-form-right-content.vue?vue&type=template&id=6c7e200b"
import script from "./left-form-right-content.vue?vue&type=script&setup=true&lang=js"
export * from "./left-form-right-content.vue?vue&type=script&setup=true&lang=js"
import style0 from "./left-form-right-content.vue?vue&type=style&index=0&id=6c7e200b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports